// About
export * from "./about.component";



// WEBPACK FOOTER //
// ./src/app/components/about/index.ts